import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { notEmpty } from "shared/lib/utils";

import { ContentItemSectionEditorPicks } from "scmp-app/components/content/content-item-render/variants/section-editor-picks";
import type { sectionEditorPicksQueue$key } from "scmp-app/queries/__generated__/sectionEditorPicksQueue.graphql";

import { Container, Header, ItemContainer, ItemWrapper } from "./styles";

type Props = {
  reference: sectionEditorPicksQueue$key;
};

const CUSTOM_QUERY_PARAMETERS = {
  module: "section_editor_picks",
  pgtype: "section",
};

export const SectionEditorPicks: FunctionComponent<Props> = ({ reference }) => {
  const data = useFragment(
    graphql`
      fragment sectionEditorPicksQueue on QueueItemsEdge @relay(plural: true) {
        node {
          ... on Content {
            entityId
            ...sectionEditorPicksContentItemContent
          }
        }
      }
    `,
    reference,
  );
  const items = data?.map(({ node }) => node).filter(notEmpty) ?? [];
  if (items.length === 0) return null;

  return (
    <Container>
      <Header>Editor&rsquo;s Picks</Header>
      <BaseLinkContextProvider customQueryParameters={CUSTOM_QUERY_PARAMETERS}>
        <ItemContainer>
          {items.slice(0, 6).map((node, index) => (
            <ItemWrapper key={node.entityId}>
              <ContentItemSectionEditorPicks
                hideImageOnMobile={index > 1}
                index={index + 1}
                reference={node}
              />
            </ItemWrapper>
          ))}
        </ItemContainer>
      </BaseLinkContextProvider>
    </Container>
  );
};
